
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaiairporttopuneertigacab() {



    const cardData =
    {
        keyword: ' Mumbai Airport to Pune Ertiga on Rent',
        heading: 'Skyline Cabs: Mumbai Airport to Pune Ertiga on Rent',
        headingDescription: 'Skyline Cabs offers convenient and affordable Mumbai Airport to Pune Ertiga on Rent service, perfect for family trips, group travel, or business transfers. Our spacious and well-maintained Ertiga ensures a comfortable ride from any terminal—T1, T2, or T3—to Pune. With professional drivers, punctual airport pickups, transparent pricing, and 24/7 customer support, Skyline Cabs guarantees a smooth and worry-free journey. Book your Ertiga from Mumbai Airport to Pune today and travel with ease and comfort.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Mumbai Airport to Pune Ertiga on Rent",
    "description": "Skyline Cabs offers Ertiga car rentals from Mumbai Airport to Pune. Enjoy a comfortable, spacious ride with our well-maintained vehicles. Ideal for families or small groups, our Ertiga rentals ensure a smooth journey from the airport to Pune at affordable rates."
  },
  {
    "name": "Mumbai to Pune Ertiga Cab",
    "description": "Book an Ertiga cab for your trip from Mumbai to Pune with Skyline Cabs. Our well-maintained Ertiga vehicles offer comfort and affordability, making it perfect for family trips, business travel, and long-distance journeys."
  },
  {
    "name": "Navi Mumbai to Pune Ertiga Cab",
    "description": "Skyline Cabs offers comfortable and affordable Ertiga cabs for your journey from Navi Mumbai to Pune. Enjoy a smooth ride with ample space and excellent service, perfect for family and group travel."
  },
  {
    "name": "Dadar to Pune Ertiga Cab Booking",
    "description": "For your trip from Dadar to Pune, book an Ertiga cab with Skyline Cabs. Our services offer an affordable and comfortable travel experience, with professional drivers ensuring a smooth ride."
  },
  {
    "name": "One Way Ertiga Cab Booking",
    "description": "Skyline Cabs provides convenient one-way Ertiga cab bookings for your journey from Mumbai to Pune or any other destination. Travel comfortably with our affordable one-way fares and well-maintained vehicles."
  },
  {
    "name": "7 Seater Car Rental Mumbai Airport",
    "description": "Skyline Cabs offers 7-seater car rentals at Mumbai Airport for large groups or families. With ample space and comfort, our vehicles are ideal for long-distance journeys, family trips, or corporate travel."
  },
  {
    "name": "6 Seater Car Rental Mumbai Airport",
    "description": "Skyline Cabs provides 6-seater car rentals at Mumbai Airport, ensuring a comfortable and spacious ride for small groups or families. Book your ride for smooth travel with affordable rates and excellent service."
  },
  {
    "name": "Pune to Mumbai Airport Drop Taxi Service",
    "description": "Book a drop taxi service from Pune to Mumbai Airport with Skyline Cabs. Our reliable and affordable service ensures timely arrival, so you can travel stress-free with well-maintained vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Pune Ertiga Hire",
    "description": "Hire an Ertiga for your trip from Mumbai to Pune with Skyline Cabs. Our Ertiga rentals are spacious, affordable, and perfect for family or group travel. Book now for a comfortable and smooth journey."
  },
  {
    "name": "Mumbai Airport Taxi Fare",
    "description": "Skyline Cabs offers transparent and competitive taxi fares for travel to and from Mumbai Airport. Whether you're traveling locally or for outstation trips, our fares are clear with no hidden charges."
  },
  {
    "name": "Airport Prepaid Taxi Mumbai",
    "description": "Skyline Cabs offers prepaid taxi services at Mumbai Airport for hassle-free and reliable transfers. Choose from a wide range of vehicles to suit your needs, and enjoy a comfortable journey to your destination."
  },
  {
    "name": "Mumbai Airport to Outstation Taxi Service",
    "description": "Skyline Cabs provides outstation taxi services from Mumbai Airport to various destinations. Our fleet includes a range of vehicles, including luxury cars and budget options, to suit all your travel needs with reliable service."
  }
],
"tableData": [
  ["Mumbai Airport to Pune Ertiga on Rent", "Mumbai to Pune Ertiga Cab"],
  ["Navi Mumbai to Pune Ertiga Cab", "Dadar to Pune Ertiga Cab Booking"],
  ["One Way Ertiga Cab Booking", "7 Seater Car Rental Mumbai Airport"],
  ["6 Seater Car Rental Mumbai Airport", "Pune to Mumbai Airport Drop Taxi Service"],
  ["Mumbai to Pune Ertiga Hire", "Mumbai Airport Taxi Fare"],
  ["Airport Prepaid Taxi Mumbai", "Mumbai Airport to Outstation Taxi Service"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Airport to Pune Ertiga Rent Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and timely Ertiga rental services from Mumbai Airport to Pune. Whether you're traveling solo, with family, or with a group, we ensure a smooth, comfortable, and hassle-free journey every time."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Ertiga",
        "WhyChoosedescription": "Our Ertiga rental service provides ample space and comfort, perfect for a family or small group. The vehicle is air-conditioned, offering plenty of legroom and a smooth ride, making your journey from Mumbai Airport to Pune enjoyable and relaxed."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are trained in safe driving practices and know the best routes from Mumbai Airport to Pune. They ensure your comfort and punctuality, providing a safe and smooth ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers affordable and transparent pricing for the Mumbai Airport to Pune Ertiga rental. You’ll know the cost upfront, with no hidden charges, ensuring you get great value for your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Our Ertiga rental service is available 24/7, meaning you can book a ride at any time, whether you’re arriving early in the morning or late at night at Mumbai Airport. We’re always ready to serve your travel needs."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your Ertiga rental is quick and easy with Skyline Cabs. Use our website or mobile app to book your ride in minutes, and receive instant booking confirmation with the ability to track your ride in real-time."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your health and safety are our top priority. All of our Ertiga vehicles are thoroughly sanitized before each ride, and our drivers follow strict hygiene protocols to ensure a clean, safe, and hygienic travel experience."
    },
    {
        "WhyChooseheading": "Comfortable and Efficient Travel Experience",
        "WhyChoosedescription": "With Skyline Cabs, you’ll enjoy a comfortable, spacious, and efficient travel experience from Mumbai Airport to Pune in our Ertiga. Whether it’s a short trip or a long journey, we ensure a smooth and pleasant ride."
    }
]
























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent an Ertiga from Mumbai Airport to Pune with Skyline Cabs?',
            answer:
                'Renting an Ertiga from Mumbai Airport to Pune is simple with Skyline Cabs. You can book through our website, mobile app, or by calling our customer support. Just enter your terminal, pickup and drop details, choose Ertiga as your vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'Why should I choose an Ertiga for the Mumbai Airport to Pune journey?',
            answer:
                'Ertiga is a versatile and spacious MPV, perfect for family travel or small groups. It offers comfort, ample luggage space, and a smooth ride, making it ideal for the Mumbai Airport to Pune route.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Mumbai Airport to Pune in an Ertiga?',
            answer:
                'The travel time typically ranges from 3.5 to 5 hours, depending on the traffic and terminal. Our professional drivers choose the best routes for a timely and comfortable trip.',
        },
        {
            id: 4,
            question: 'Is the rental fare for an Ertiga from Mumbai Airport to Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent pricing for Ertiga rentals. The fare includes all taxes, tolls, and driver charges—no hidden costs.',
        },
        {
            id: 5,
            question: 'Can I book an Ertiga for a round-trip from Mumbai Airport to Pune?',
            answer:
                'Absolutely. When booking, just mention your return trip details and we’ll arrange a round-trip ride in an Ertiga for your convenience.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Mumbai Airport to Pune Ertiga booking?',
            answer:
                'Yes, we offer flexible booking policies. You can modify or cancel your booking anytime via our app, website, or customer support team.',
        },
        {
            id: 7,
            question: 'Are the Ertiga cabs well-maintained and clean?',
            answer:
                'Yes, all our Ertigas are regularly serviced and thoroughly cleaned to ensure a safe, hygienic, and pleasant travel experience.',
        },
        {
            id: 8,
            question: 'What payment options are available for renting an Ertiga from Mumbai Airport to Pune?',
            answer:
                'You can pay securely online using credit/debit cards, UPI, or net banking. Cash payment is also available at the end of the ride.',
        },
        {
            id: 9,
            question: 'Is Ertiga a good option for corporate or group travel from Mumbai Airport to Pune?',
            answer:
                'Yes, Ertiga is an excellent option for corporate and group travel. It offers space, comfort, and a professional look suitable for both leisure and business needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for an Ertiga rental from Mumbai Airport to Pune?',
            answer:
                'Skyline Cabs ensures timely pickups, fixed fares, well-maintained Ertiga vehicles, and courteous drivers. We’re committed to offering a hassle-free experience from Mumbai Airport to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked an Ertiga from Mumbai Airport to Pune for a family trip. It was spacious and comfortable, and the driver was very cooperative. Excellent service by Skyline Cabs!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a smooth experience with Skyline Cabs. Rented an Ertiga from the airport to Pune and the car was in great condition. Would definitely recommend!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Ertiga on Rent",
  "image": "https://skylinecabs.com/assets/images/mumbai-airport-to-pune-ertiga-cab.jpg",
  "description": "Hire Ertiga from Mumbai Airport to Pune with Skyline Cabs. Spacious, air-conditioned 6-seater cabs perfect for families and small groups—available 24/7 for Terminal 1 & 2 pickups with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7621"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-airport-to-pune-ertiga-rental"
  }
};



      
      



    return (
        <div>
<Helmet>
  <title>Mumbai Airport to Pune Ertiga on Rent | 6-Seater SUV | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Hire Ertiga from Mumbai Airport to Pune with Skyline Cabs. Spacious, air-conditioned 6-seater cabs perfect for families and small groups—available 24/7 for Terminal 1 & 2 pickups with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Ertiga, Ertiga Rental Mumbai Airport to Pune, 6 Seater Cab Mumbai Airport to Pune, Ertiga on Rent Mumbai Pune, Terminal 1 to Pune Ertiga, Terminal 2 to Pune SUV, AC Ertiga Mumbai to Pune, Family Cab Mumbai Pune, Skyline Cabs Ertiga Hire" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopuneertigacab;